const $$splitComponentImporter = () => import('/Users/Javvad_1/Desktop/Petso_Dev/monorepo/petso-pro/src/routes/dashboard/payments.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/dashboard/payments')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});

// ─── Types ────────────────────────────────────────────────────────────────────

type PaymentMethod = 'all' | 'cash' | 'card' | 'bank_transfer' | 'stripe';
interface Payment {
  id: string;
  invoiceId: string;
  invoiceNumber: string;
  customerName: string;
  amount: number;
  method: string;
  reference?: string;
  date: string;
}
// ─── Component ────────────────────────────────────────────────────────────────

type PageTab = 'payments' | 'stripe';
interface StripeStatus {
  connected: boolean;
  connectedVia?: 'direct_keys' | 'stripe_connect';
  mode?: 'test' | 'live';
  platformConfigured?: boolean;
  encryptionAvailable?: boolean;
  // Direct keys fields
  publishableKey?: string;
  secretKeyMasked?: string;
  webhookSecretMasked?: string;
  hasWebhookSecret?: boolean;
  configured?: boolean;
  // Connect fields
  stripeAccountId?: string;
  account?: {
    id: string;
    businessProfile?: {
      name?: string;
      url?: string;
    };
    chargesEnabled: boolean;
    payoutsEnabled: boolean;
    email?: string;
  };
}